import React, { useMemo, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import every from 'lodash/every';
import Locale from '@active/react-utils/i18n/Locale';
import PaymentOptions from './components/PaymentOptions';
import PaymentMethods from './components/PaymentMethods';
import pubSubInstance from '../../../shared/utils/pubSub';

const Payment = ({
  className,
  PaymentMethodNode,
  trackingCallback,
}) => {
  const {
    widgetNameSpace,
  } = useSelector(state => state.propsData);

  const paymentOptions = useSelector(state => state.paymentOptions);

  const { isRenderPaymentOptions } = paymentOptions || {};
  const isShowPaymentOptions = !!paymentOptions; // cof not show PaymentOptions section

  const {
    isRenderPaymentMethods,
  } = useSelector(state => state.paymentMethods);

  const classes = useMemo(() => classnames({
    'second-level-title': true,
    'payment-title': true,
  }, className), [ className ]);

  const handleValidate = useCallback(() => {
    return new Promise((resolve) => {
      pubSubInstance.dispatch(`${widgetNameSpace}-payment-item-validate`, undefined, (res) => {
        const isValidate = every(res, (value) => { return value === true; });
        resolve(isValidate);
      });
    });
  }, [ widgetNameSpace ]);

  const handleSubmit = useCallback(() => {
    return new Promise((resolve) => {
      pubSubInstance.dispatch(`${widgetNameSpace}-payment-item-submit`, undefined, (res) => {
        const result = res.reduce((r, v) => ({ ...r, ...v }), {});
        resolve(result);
      });
    });
  }, [ widgetNameSpace ]);

  useEffect(() => {
    pubSubInstance.subscribe(`${widgetNameSpace}-validate-block`, handleValidate);
    pubSubInstance.subscribe(`${widgetNameSpace}-submit-block`, handleSubmit);
    return () => {
      pubSubInstance.unsubscribe(`${widgetNameSpace}-validate-block`, handleValidate);
      pubSubInstance.unsubscribe(`${widgetNameSpace}-submit-block`, handleSubmit);
    };
  }, [ handleValidate, handleSubmit, widgetNameSpace ]);

  return (
    <>
      { (isRenderPaymentOptions || isRenderPaymentMethods)
        && <h2 className={classes}>
          <Locale id="checkout.lib.components.text.payment" />
        </h2>
      }
      {isShowPaymentOptions && <PaymentOptions />}
      {PaymentMethodNode ? <PaymentMethodNode /> : <PaymentMethods trackingCallback={trackingCallback}/>}
    </>
  );
};

export default Payment;
